// --- Views
import SelectFlow from '@/views/e-commerce-v2/SelectFlow.vue';
import EmptyRouterView from '@/views/shared/EmptyRouterView2.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';

// Sub Routes
import PersonalizedPaymentRoute from './personalized-payment';
import ExploreCalculatorRoute from './explore-calculator';

export default [
  {
    path: '',
    redirect: { path: 'select-e-commerce-flow' },
  },
  {
    path: 'select-e-commerce-flow',
    component: SelectFlow,
    meta: {
      headerIcon: false,
      hasNext: true,
      headerStyleClasses: 'mb-0',
    },
  },
  {
    path: 'personalized-payment',
    component: EmptyRouterView,
    children: PersonalizedPaymentRoute,
    redirect: { path: 'personalized-payment/step-one' },
  },
  {
    path: 'explore-calculator',
    component: EmptyRouterView,
    children: ExploreCalculatorRoute,
    redirect: { path: 'explore-calculator/payment-calculator' },
  },
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      nextRoutePath: 'payment-calculator',
      errorPayload: null,
    },
  },
  {
    path: 'lead-expired',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: false,
      errorPayload: {
        errorType: 'expired',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
